import { ListRow, Separator, Text } from '@betterment/samba-react';

import { LeadingIcon } from './LeadingIcon';

export const CheckingUnavailableRow: React.FC<{ iconUrl: string }> = ({ iconUrl }) => (
  <>
    <ListRow>
      <ListRow.LeadingAsset>
        <LeadingIcon url={iconUrl} />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text color="text">Checking</Text>
        <Text variant="text50" color="text.weak">
          Unavailable
        </Text>
      </ListRow.LeadingContent>
    </ListRow>
    <Separator css={{ fullWidthWithInset: 'space.300' }} />
  </>
);
